// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__11Z05","messages":"Chat_messages__3wUSp","dateDivider":"Chat_dateDivider__2vEa9"};